export const POLYGON_TYPES = {
    CHARGE_STATION: "chargeStation",
    JOB_SITE: "jobSite",
    NONE: "none",
    PROJECT_AREA: "projectArea"
};
